import React, { Component, lazy, Suspense } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';

import * as userActions from '../actions/userActions';
import * as collabActions from '../actions/collabActions';

import { s3CacheUrl } from './Common/util';

import { BlairstoneQuote, BlairstoneBio } from './CollabArtists/Blairstone';
import { OTSQuote, OTSBio } from './CollabArtists/OTS';
import { LAUNQuote, LAUNBio } from './CollabArtists/LAUN';
import { SoWQuote, SoWBio } from './CollabArtists/SoW';
import { SswtrQuote, SswtrBio } from './CollabArtists/SSWTR';
import { CasertaQuote, CasertaBio } from './CollabArtists/Caserta';
import { DaultQuote, DaultBio } from './CollabArtists/Dault';
import { KreimerQuote, KreimerBio } from './CollabArtists/Kreimer';
import { PenderQuote, PenderBio } from './CollabArtists/Pender';
import { ZuckerQuote, ZuckerBio } from './CollabArtists/Zucker';

const GlobalNav = lazy(() => import('./Headers/GlobalNav'  /* webpackChunkName: "globalnav" */));
const Header = lazy(() => import('./Headers/Header'  /* webpackChunkName: "header" */));
const FooterShop = lazy(() => import('./Footers/FooterShop'  /* webpackChunkName: "footershop" */));


class CollabBadge extends Component {
  render() {
    if (this.props.collab) {
      return (
        <img
          alt={''}
          src={
            s3CacheUrl('https://s3.amazonaws.com/weft-public-assets/images/ui/shop-svg/weft-collab-badge.svg')
          }
          className={'shop-fabric-badge'}
        />
      );
    } else {
      return <div className={'hidden'} />;
    }
  }
}

class FabricTile extends Component {
  renderImage(image) {
    return (<div style={{backgroundImage: `url(${image})`}} className="shop-fabric-tile-thumbnail" />);
  }

  render() {
    var coverImage = this.props.colorway.images.length > 0 ? s3CacheUrl(this.props.colorway.images[0].image, 225) : 'https://placehold.it/300?text=no+image';

    return (
      <div className={'shop-fabric-tile tile is-3'}>
        <a href={`/shop/fabric/${this.props.colorway.product.fabric_id}/${this.props.colorway.colorway_id}`}>
          <CollabBadge collab={this.props.colorway.product.artist_collab} />
          {this.renderImage(coverImage)}

          <div className={'shop-fabric-tile-text-container'}>
            <div className={'shop-fabric-tile-text'}>
              {this.props.colorway.product.name}
            </div>
            <div className={'shop-fabric-tile-text'}>
              {this.props.colorway.name}
            </div>
            <div className={'shop-fabric-tile-text'}>
              ${this.props.colorway.product.price_per_yard} / yard
            </div>
          </div>
        </a>
      </div>
    );
  }
}

class FabricTileFiller extends Component {
  render() {
    return (<div className={"shop-fabric-tile tile is-3 filler"} />);
  }
}

class FabricList extends Component {
  createRows(colorways) {
    return colorways.map((e, i) => ((i % 4 === 0) ? colorways.slice(i, i+4) : null))
    .filter(cg => cg);
  }

  render() {
    return (
      <div className={'collab-artist-fabric-list-container'}>
        {this.createRows(this.props.colorways).map((cr, i) => {
          return (
            <div className={'tile is-ancestor'} key={`fabric_list_${i}`}>
              {cr[0] ? <FabricTile colorway={cr[0]} /> : <FabricTileFiller />}
              {cr[1] ? <FabricTile colorway={cr[1]} /> : <FabricTileFiller />}
              {cr[2] ? <FabricTile colorway={cr[2]} /> : <FabricTileFiller />}
              {cr[3] ? <FabricTile colorway={cr[3]} /> : <FabricTileFiller />}
            </div>
          );
        })}
      </div>
    );
  }
}

class CollabArtist extends Component {
  getQuote(slug) {
    switch(slug){
      case 'kate-blairstone':
        return(<BlairstoneQuote />);
      case 'slow-and-steady-wins-the-race-vonnegut-kraft':
        return(<SswtrQuote />);
      case 'john-caserta':
        return(<CasertaQuote />);
      case 'julia-dault':
        return(<DaultQuote />);
      case 'julian-kreimer':
        return(<KreimerQuote />);
      case 'stefanie-pender':
        return(<PenderQuote />);
      case 'kevin-zucker':
        return(<ZuckerQuote />);
      case 'society-of-wonderland':
        return(<SoWQuote />);
      case 'katherine-flynn-laun':
        return(<LAUNQuote />);
      case 'office-of-tangible-space':
        return(<OTSQuote />);
      default:
        return(<div />);
    }
  }

  getBio(slug) {
    switch(slug){
      case 'kate-blairstone':
        return(<BlairstoneBio />);
      case 'slow-and-steady-wins-the-race-vonnegut-kraft':
        return(<SswtrBio />);
      case 'john-caserta':
        return(<CasertaBio />);
      case 'julia-dault':
        return(<DaultBio />);
      case 'julian-kreimer':
        return(<KreimerBio />);
      case 'stefanie-pender':
        return(<PenderBio />);
      case 'kevin-zucker':
        return(<ZuckerBio />);
      case 'society-of-wonderland':
        return(<SoWBio />);
      case 'katherine-flynn-laun':
        return(<LAUNBio />);
      case 'office-of-tangible-space':
        return(<OTSBio />);
      default:
        return(<div />);
    }
  }

  getBackgroundImageUrl() {
      // Hack to get the right collab image to display
      if(this.props.collab && this.props.collab.slug === 'slow-and-steady-wins-the-race-vonnegut-kraft') {
        return `url(${s3CacheUrl('https://s3.amazonaws.com/weft-shop-media/media/fabric-product-images/Weft_Collab_SSWTR.jpg', 640)})`;
      } else  if (this.props.collab && this.props.collab.slug === 'society-of-wonderland') {
        return `url(${s3CacheUrl('https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/sow/WeftOut_Dafne_126.jpg', 640)})`;
      } else  if (this.props.collab && this.props.collab.slug === 'katherine-flynn-laun') {
        return `url(${s3CacheUrl('https://s3.amazonaws.com/weft-public-assets/images/weft-shop-hp/Weft_LAUN_HP_01.jpg', 640)})`;
      } else if (this.props.collab && this.props.collab.slug === 'office-of-tangible-space') {
          return `url(${s3CacheUrl('https://s3.amazonaws.com/weft-public-assets/images/weft-shop-hp/Weft_OTS_HP_01.jpg', 640)})`;
      } else if (this.props.collab && this.props.collab.slug === 'kate-blairstone') {
        return `url(${s3CacheUrl('https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/blairstone/blairstone_fish_02.png', 640)})`;
      } else {
        return `url(${this.props.collab && this.props.collab.colorways.length > 0 ? s3CacheUrl(this.props.collab.colorways[0].product.images[0].image, 730) : ''})`;
      }
  }

  render() {
    // Generat next collab link
    var nextCollabLink = '/shop?filter=collab';

    if(this.props.collabs.length > 0 && this.props.collab) {
      var nextIndex = this.props.collabs.filter(c => c.published === true).findIndex(c => c.slug === this.props.collab.slug);

      if(nextIndex >= 0) {
        nextIndex += 1;
        if (nextIndex > (this.props.collabs.length - 1))
          nextIndex = 0;

        nextCollabLink = `/collab-artist/${this.props.collabs[nextIndex].slug}`;
      }
    }

    if(this.props.collabFetching) {
      return(
        <div className={"collab-artist-container"}>
          <div className={'shop-loading'}>
            <img src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/ui/create-svg/weft-loading-yellow.svg")} alt="" />
          </div>
        </div>
      );
    } else {
        let bannerClass = "collabs-banner-image tile is-5";
        if (this.props.collab && this.props.collab.slug === 'katherine-flynn-laun') {
          bannerClass += " bg-bottom";
        }

        return(
        <div>
          <div className={"collabs-section grey tile is-ancestor"}>
            {this.getQuote(this.props.collab ? this.props.collab.slug : <div className={'tile is-5'} />)}

            <div className={bannerClass}
              style={{backgroundImage: this.getBackgroundImageUrl()}}
            />
          </div>

          <div className={"collab-artist-container"}>
            <div className={'collabs-shop-button-container'}>
              <button className={"collabs-shop-button"}>
                <Link to={"/collabs"}><i className={'material-icons rev'}>play_arrow</i> SHOP ALL COLLABS</Link>
              </button>

              <button className={"collabs-shop-button"}>
                <Link to={nextCollabLink}>NEXT COLLAB<i className={'material-icons'}>play_arrow</i></Link>
              </button>
            </div>

            <FabricList
              colorways={this.props.collab ? this.props.collab.colorways : []}
            />

            {this.getBio(this.props.collab ? this.props.collab.slug : '')}

          </div>
        </div>
      );
    }
  }
}

class CollabArtistPage extends Component {
  componentWillMount () {
    if(this.props.isAuthenticated) {
      this.props.jwtAuth();
    }
  }

  componentDidMount() {
    this.props.fetchCollabData();
    this.props.fetchCollabData(this.props.collab_slug)
    .then(data => {
      if(this.props.collab && this.props.collab.name)
        document.title = `${this.props.collab.name} | Weft`;
      else
        document.title = 'Collabs | Weft';
    });
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.collab_slug !== nextProps.collab_slug) {
      this.props.fetchCollabData(nextProps.collab_slug)
      .then(data => {
        if(this.props.collab && this.props.collab.name)
          document.title = `${this.props.collab.name} | Weft`;
        else
          document.title = 'Collabs | Weft';
      });
    }
  }

  render() {
    return (
      <section className={'collab-artist-page'}>
        <Suspense fallback={<div>Loading...</div>}>
          <Header />

          <GlobalNav />

          <CollabArtist {...this.props} />

          <FooterShop />
        </Suspense>
      </section>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    collab_slug: props.match.params.slug,
    isAuthenticated: state.user.isAuthenticated,
    collabFetching: state.collabs.collabFetching,
    collab: state.collabs.collab,
    collabs: state.collabs.collabs ? state.collabs.collabs : [],
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({...userActions, ...collabActions}, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CollabArtistPage));
